import React from "react";
import { Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import { Button } from "react-bootstrap";
import { DetailsDataTable } from "../../inventory/DetailsView/details-table/details-table.component";
export class AddCostAllocation extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:""
        }
    }
    render(){
        return(
            <div className="manage-order-container">
                <div className="custom-col-350-4 manage-order-details">
                    <InputField label="GL CODE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="COST CENTER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="PERCENT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <div className="label-button-container">
                        <Button className="line-item-cancel-button"> Cancel </Button>
                        <Button className="line-item-save-button"> Add </Button>
                    </div>                                      
                </div>
                <DetailsDataTable datatable={this.props.dataTable} haveEditBtn={true} haveDeleteBtn={true} />                                  

            </div>  
        )
    }
}